/** Creates an abortable events HTML API that rejects unsuccessful HTTP responses. */
export function createEventsResultsApi({ fetch = globalThis.fetch } = {}) {
  async function request(url, { signal } = {}) {
    const response = await fetch(url, { signal, headers: { "X-Requested-With": "XMLHttpRequest" } });
    if (!response.ok) {
      throw new Error(`Events results request failed (${response.status})`);
    }
    return { result: await response.text() };
  }
  return Object.freeze({ fetch: request });
}
